'use strict';

/*global Container */
/*global Translator */
/*global DevelopmentTools */
/*global Notifications*/
/*global MapsContainer*/
/*global MapAddressLoaderGoogle*/

var services = new Container();

$(document).ready(function () {
    services.set('translator', new Translator('translations'));
    services.set('development', new DevelopmentTools());
    services.set('notifications', new Notifications());
    services.set('maps_container', new MapsContainer());
});
